<template>
  <div class="page">
    <c-source-detail
      :columns="columns"
      :data="data"
      resource="property_names"
    />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import createColumns from './columns';

@Component
export default class PropertynamesShow extends Vue {
  data = {}

  get columns() {
    return createColumns.call(this)
  }

  async mounted() {
    this.data = await this.$request.get(`/property_names/${this.$route.params.id}`);
  }
}
</script>
